export default function useCountdown(storageKey, total) {
  const current = ref(0);
  const running = ref(false);
  let timer;

  const start = (remains = total) => {
    if (timer) clearInterval(timer);
    if (remains === total) localStorage.setItem(storageKey, Date.now());

    running.value = true;
    current.value = remains;

    return new Promise((resolve) => {
      const interval = setInterval(() => {
        current.value -= 1;

        if (current.value === 0) {
          running.value = false;
          clearInterval(interval);
          resolve();
        }
      }, 1000);
    });
  };

  const reset = () => {
    if (timer) clearInterval(timer);
    running.value = false;
    current.value = 0;
    localStorage.removeItem(storageKey);
  };

  onMounted(() => {
    const lastStartTime = parseInt(localStorage.getItem(storageKey), 10) || 0;
    const remains = Math.ceil(total - (Date.now() - lastStartTime) / 1000);

    if (remains > 0) {
      start(remains);
    }
  });

  return reactive({
    current,
    running,
    start,
    reset,
  });
}
